import { render, staticRenderFns } from "./plantilla_etiqueta.vue?vue&type=template&id=067834f5&"
import script from "./plantilla_etiqueta.vue?vue&type=script&lang=js&"
export * from "./plantilla_etiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports